const contextTypesMap = {
  admin: 'admin',
  my_account: 'my_account',
  frontend: 'frontend',
}

export default contextTypesMap
